import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.324 10.979C14.423 9.256 9.637 9.097 6.868 9.938a.841.841 0 1 1-.489-1.611c3.18-.965 8.464-.779 11.804 1.204a.842.842 0 0 1-.86 1.448m-.094 2.551a.7.7 0 0 1-.965.232c-2.419-1.487-6.107-1.918-8.969-1.05a.703.703 0 0 1-.822-1.001.7.7 0 0 1 .415-.34c3.268-.993 7.332-.512 10.11 1.195.33.203.433.635.23.964m-1.101 2.451a.56.56 0 0 1-.772.187c-2.113-1.292-4.773-1.584-7.906-.868a.561.561 0 1 1-.25-1.094c3.428-.783 6.37-.446 8.741 1.004a.56.56 0 0 1 .187.771M12 3a9 9 0 0 0 0 18 9 9 0 1 0 0-18"
    }, null, -1)
  ])))
}
export default { render: render }